import { combineReducers } from "redux";
import dashboard from "./reducers/dashboard";
import worker from "./reducers/worker";
import user from "./reducers/user";

export default combineReducers({ dashboard, worker, user });
